import { Component, Input, ViewEncapsulation, OnChanges, SimpleChanges, OnInit } from '@angular/core';

export interface IStep {
    stepID: number;
    label: string;
    header: string;
    prevButton: { title: string  };
    nextButton: { title: string };

}

@Component({
  selector: 'nbx-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom
})

export class StepperComponent implements OnInit, OnChanges{
  defaultsteps = 2;
  @Input() orientation = "horizontal";
  @Input() linearMode = "Disable";
  @Input() steps = this.defaultsteps;
  @Input() labels: string = '';
  @Input() buttonNext ='Next'
  @Input() buttonPrev ='Prev'
  numbers = [];
  length = this.numbers.length
  initialized = false;

  current = this.steps;

  labelList = [];
  

  ngOnInit() {
    if (this.labels  !== '')
    {
      this.labelList = this.labels.split(',');
    }
    this.createSteps(this.steps)
    this.initialized = true;
  }

  ngOnChanges (changes: SimpleChanges) {
    for(const propName in changes)
    {
      if (changes.hasOwnProperty(propName) && this.initialized === true) {
        switch(propName) {
          case 'steps': {
            if (this.steps > 1) {
              this.numbers = [];
              this.createSteps(this.steps);
            }
          }
          case 'labels': {
            if (this.labels !== '') {
              this.labelList = this.labels.split(',');
              this.numbers = [];
              this.createSteps(this.steps);
            }
          }
        }
      }
    }
  }
  
  createSteps(num) {
    for (var i = 0; i < num; i++) {
      this.addStep(i+1);
    }
  }

  addStep(idVal) {
    var offset = idVal;
      var newStep = {
        stepID: offset,
        label: this.getLabel(idVal-1), 
        header: "",
        prevButton: { title: this.buttonPrev },
        nextButton: { title: this.buttonNext },
        stepName: 'step_content_'+ (idVal)
      }

      this.numbers.push(newStep);
      this.length = this.numbers.length;
      console.log(this.length);
  }

  getLabel(index) {

    var defaultLabel = 'Step '+ (index + 1);

    if (this.labelList.length > 0)
    {
      if (this.labels[index] !==undefined && this.labelList[index] !== '' )
      {
        return this.labelList[index];
      }
    }
    return  defaultLabel;
  }

  removeStep() {
    
  }
 
}